<template>
  <sui-page-contents>
    <sui-grid ref="grid" :columns="gridColumns0" :autoheight="false" :pageable="false" :autoShrink="true" :dataset="'dataset0'" :initialPagesize="5" :filterable="false" :sortable="false" :multiselect="true">
    </sui-grid>
  </sui-page-contents>
</template>
<script>
  import LangSelect from '~common/components/form/SuiLangSelect/SuiLangSelect';
  export default {
    name: 'DatasetWithComponent',
    data() {
      return {
        gridColumns0: [
          {
              text: 'rowId',
              datafield: 'dataset-row-id',
              width: '50px',
          },
          {
            text: 'stateButton',
            datafield: 'stateButton',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
                  type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);



            },
          },
          {
            text: 'multiUserSelect',
            datafield: 'multiUserSelect',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellMultiUserSelect(row, column, value, htmlElement, {

              }, this.dataset0, this.$refs.grid);

            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          {
            text: 'multiUserSelectAdv',
            datafield: 'multiUserSelectAdv',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellMultiUserSelectAdv(row, column, value, htmlElement, {

              }, this.dataset0, this.$refs.grid);

            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          {
            text: 'userSelect',
            datafield: 'userSelect',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellUserSelect(row, column, value, htmlElement, {
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          {
            text: 'stateButton2',
            datafield: 'stateButton2',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
                useSurfixIcon: true,
                type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          {
            text: 'label',
            datafield: 'label',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellLabel(row, column, value, htmlElement, {
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
          {
            text: 'labelWithTooltip',
            datafield: 'labelWithTooltip',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellLabel(row, column, value, htmlElement, {
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },
        ],
        localdata0: [{
            "userSelect": null,
            "multiUserSelect": [],
            "multiUserSelectAdv": [],
            "stateButton": { text: '공지사항 새글이면 뉴아이콘이 붙어요', 'shownew': true},
            "stateButton2": { text: 'button2', 'showattach': true },
            "label": 'tooltip이 label과 동일',
            "labelWithTooltip": { text: 'label', tooltip: 'tooltip이 label과 상이' },
          },
        ],
      };
    },
    mounted() {
      const newData = [];
      for (let i = 0; i < 10; i++) {
        this.localdata0.forEach(data => {
          newData.push(_.clone(data));
        });
      }
      this.dataset0.setRawData(newData);
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [
        {
          "name": "dataset-row-id",
          "type": "string",
          "map": "dataset-row-id"
        },
        {
          "name": "userSelect",
          "type": "string",
          "map": "userSelect"
        },
        {
          "name": "multiUserSelect",
          "type": "object",
          "map": "multiUserSelect"
        },
        {
          "name": "multiUserSelectAdv",
          "type": "object",
          "map": "multiUserSelectAdv"
        },
        {
          "name": "stateButton",
          "type": "object",
          "map": "stateButton"
        },
        {
          "name": "stateButton2",
          "type": "object",
          "map": "stateButton2"
        },
        {
          "name": "label",
          "type": "string",
          "map": "label"
        },
        {
          "name": "labelWithTooltip",
          "type": "object",
          "map": "labelWithTooltip"
        },

      ]
    }],
    methods: {
    }
  };
</script>
<style scoped></style>
